import De from "../messages/de.json";
import En from "../messages/en.json";
import Es from "../messages/es.json";
import Fr from "../messages/fr.json";
// import KoKr from '../../messages/ko-kr.json';
import Ru from "../messages/ru.json";
// import Tr from "../messages/tr.json";
import UkUa from "../messages/uk-ua.json";
import Vi from "../messages/vi.json";
import Pt from "../messages/pt.json";
// import ZhTw from '../../messages/zh-tw.json';

const Languages = {
  en: En,
  es: Es,
  de: De,
  fr: Fr,
  // tr: Tr,
  ru: Ru,
  "uk-ua": UkUa,
  vi: Vi,
  pt: Pt
};

export type LanguagesType = keyof typeof Languages;

export type MessagesType = keyof typeof En.header;

export { Languages };

export type Theme = "light" | "dark";

export interface UsuallyResponse<T> {
  code: number;
  data: T;
  msg: string;
}
